<template>
  <div class="detailInfo">
    <div class="info">
      <div class="info-top" style="padding: 5px;">
        <p>{{order.type==0?"充值":order.type==1?"退款":order.type==7?"充值赠送":"消费"}}</p>
        <h2>{{order.money>0?'+':''}}{{$moneyFormat.RMB(order.money)}}</h2>
      </div>
      <div>
        <van-cell :value="order.type==0?'充值':order.type==1?'退款':order.type==7?'充值赠送':'消费'" title="类型:" />
        <van-cell :value="order.recordTime" title="时间:" />
        <van-cell :value="order.orderId" title="交易单号:"  />
        <van-cell :value="'¥'+order.balance" title="余额:" />
      </div>
    </div>
  </div>
</template>

<script>
    import { mySessionStorage } from '@/utils/storage.js'
  export default {
    data() {
      return {
        id: "",
        isNull: false,
        order: {
        }
      };
    },
    methods: {
      getList(){
        this.$http.post(this.$api.walletDetailInfo + "/" + this.id, {}).then(res => {
          this.order = res.data;
        });
      }
    },
    created() {
      this.id = this.$route.query.id;
      this.getList();
    }
  };
</script>

<style>
  .detailInfo {
    background-color: #F0F0F0;
    height: 100%;
    width: 100%;
    padding-top: 1px;
  }

  .info {
    background: white;
    margin: 2%;
  }
  .info-top{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/user/wallet/detailInfo.vue